import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { showPopup } from '../../UI/UIStateHelper';
import { ICoinsActionPayload } from '../PlayerActions';
import { setCoins } from '../PlayerInventoryHelper';

export function receiveCoins(state: IGameState, payload: ICoinsActionPayload) {
    state = {
        ...state,
        playerState: setCoins(
            state.playerState,
            state.playerState.coins + payload.coins
        ),
    };
    trackTransaction(state, TransactionType.REWARD, TActionType.REWARD);
    if (payload.showPopup) {
        state.UIState = showPopup(state.UIState, 'receiveCoinsMenu', {
            coins: payload.coins,
        });
    }
    return state;
}
